<div class="text-center">

    <div class="d-flex flex-column">
      <div class="d-flex justify-content-center" *ngIf="useIcon">
        <ng-container *ngFor="let i of [].constructor(iconCount)">
          <i [ngClass]="classIcon" aria-hidden="true" [id]="i+'iconId'"></i>
        </ng-container>
      </div>
      <label class="control-label">{{ text | translate }} </label>
    </div>
  
    <div class="d-flex flex-row justify-content-between">
      <button class="btn btn-danger btn-custom-picker align-self-center"
        style="height: 48px !important; border-radius: 15px 0 0 15px !important;" (click)="emitDecrease()"
        [disabled]="model <= min"><i class="fa fa-times" aria-hidden="true"></i></button>
      <input [disabled]="true" class="form-control text-center" style="font-size: 22px" type="text" [(ngModel)]="model"
        name="input{{text}}" syle="border-radius: 0px !important">
      <button class="btn btn-success btn-custom-picker align-self-center"
        style="height: 48px !important; border-radius: 0px 15px 15px 0px !important" (click)="emitIncrease()"
        [disabled]="model >= max"><i class="fa fa-plus" aria-hidden="true"></i></button>
    </div>
</div>
